import type { IncomeEmploymentTabProps } from "../../types/tabs";
import { useIncomeEmploymentTab } from "./income-employment/useIncomeEmploymentTab";
import { IncomeEmploymentEditView } from "./income-employment/IncomeEmploymentEditView";
import { IncomeEmploymentReadOnlyView } from "./income-employment/IncomeEmploymentReadOnlyView";

export function IncomeEmploymentTab(props: IncomeEmploymentTabProps) {
  const { isEdit, editViewProps, readOnlyViewProps } =
    useIncomeEmploymentTab(props);

  if (isEdit) {
    return <IncomeEmploymentEditView {...editViewProps} />;
  }

  return <IncomeEmploymentReadOnlyView {...readOnlyViewProps} />;
}
